<!-- Операционные связи расхода с транспортом, рейсом, путевым листом и ремонтом. -->
<template>
  <BaseFormSection title="Связи" icon="truck">
    <BaseFormField
      label="Заказ"
      for-id="order"
      :filled="isFieldFilled('order_id')"
    >
      <OrderSelect
        id="order"
        :model-value="expense.order_id"
        placeholder="Выберите заказ"
        @update:model-value="handleFieldChange('order_id', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Транспорт"
      for-id="vehicle"
      :filled="isFieldFilled('vehicle_id')"
      wide
    >
      <div class="vehicle-picker">
        <FleetParkSelect
          id="fleet_park"
          :model-value="expense.fleet_park_id"
          placeholder="Все автопарки"
          :with-button="false"
          @change="$emit('fleet-park-change')"
          @update:model-value="
            handleFieldChange('fleet_park_id', $event)
          "
        />

        <VehicleSelect
          id="vehicle"
          :model-value="expense.vehicle_id"
          placeholder="Выберите транспорт"
          :fleet-park-id="expense.fleet_park_id"
          @update:model-value="handleFieldChange('vehicle_id', $event)"
          @vehicle-change="$emit('vehicle-change', $event)"
        />
      </div>
    </BaseFormField>

    <BaseFormField
      label="Путевой лист"
      for-id="waybill"
      :filled="isFieldFilled('waybill_id')"
    >
      <WaybillSelect
        id="waybill"
        :model-value="expense.waybill_id"
        placeholder="Выберите путевой лист"
        @update:model-value="handleFieldChange('waybill_id', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Рейс"
      for-id="trip"
      :filled="isFieldFilled('trip_id')"
    >
      <TripSelect
        id="trip"
        :model-value="expense.trip_id"
        placeholder="Выберите рейс"
        @update:model-value="handleFieldChange('trip_id', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Ремонт"
      for-id="fleet_repair"
      :filled="isFieldFilled('fleet_repair_id')"
    >
      <FleetRepairSelect
        id="fleet_repair"
        :model-value="expense.fleet_repair_id"
        placeholder="Выберите ремонт"
        @update:model-value="
          handleFieldChange('fleet_repair_id', $event)
        "
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
import FleetRepairSelect from "@/components/Fleet/Repair/Select.vue";
import OrderSelect from "@/components/Order/OrderSelect.vue";
import FleetParkSelect from "@/components/Vehicle/FleetParkSelect.vue";
import TripSelect from "@/components/Trip/TripSelect.vue";
import VehicleSelect from "@/components/Vehicle/VehicleSelect.vue";
import WaybillSelect from "@/components/Waybill/WaybillSelect.vue";

export default {
  name: "ExpenseLinksSection",

  components: {
    FleetRepairSelect,
    OrderSelect,
    FleetParkSelect,
    TripSelect,
    VehicleSelect,
    WaybillSelect,
  },

  props: {
    expense: { type: Object, required: true },
  },

  emits: ["fleet-park-change", "update-field", "vehicle-change"],

  methods: {
    handleFieldChange(field, value) {
      this.$emit("update-field", field, value);
    },

    isFieldFilled(field) {
      const value = this.expense[field];
      return value !== null && value !== undefined && value !== "";
    },
  },
};
</script>

<style scoped>
.vehicle-picker {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--base-in-indent);
}

@media (max-width: 900px) {
  .vehicle-picker {
    grid-template-columns: 1fr;
  }
}
</style>
